// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const MaximumAgentsLimitReachedDialogLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-maximumagentslimitreacheddialogcontainer" */ "./MaximumAgentsLimitReachedDialogContainer")).then((bundle)=>{
        return {
            default: bundle.MaximumAgentsLimitReachedDialogContainer
        };
    });
export const LazyMaximumAgentsLimitReachedDialogContainer = /*#__PURE__*/ lazy(MaximumAgentsLimitReachedDialogLazyLoader);
